import * as React from "react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

const statusPillVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      status: {
        healthy: "border-transparent bg-admin-success/10 text-admin-success",
        degraded: "border-transparent bg-admin-warning/10 text-admin-warning",
        critical: "border-transparent bg-admin-danger/10 text-admin-danger",
        pending: "border-transparent bg-admin-info/10 text-admin-info",
        approved: "border-transparent bg-admin-success/10 text-admin-success",
        rejected: "border-transparent bg-admin-danger/10 text-admin-danger",
        active: "border-transparent bg-admin-success/10 text-admin-success",
        inactive: "border-transparent bg-muted text-muted-foreground",
      },
    },
    defaultVariants: {
      status: "healthy",
    },
  }
)

export interface StatusPillProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statusPillVariants> {
  label?: string
}

export function StatusPill({ className, status, label, children, ...props }: StatusPillProps) {
  return (
    <Badge
      className={cn(statusPillVariants({ status }), className)}
      {...props}
    >
      {label || children}
    </Badge>
  )
}

